import React from 'react';
import NotesIcon from '@mui/icons-material/Notes';
import { Container, RightContainer, Title, DropdownContainer } from './styled';
import  DropdownComplexidade  from './DropdownComplexidade';

const Complexidade = () => {  
	
  return (
  <Container >    
    <NotesIcon fontSize='small' />
      <RightContainer>
        <Title>Complexidade</Title>
        <DropdownContainer>
					<DropdownComplexidade title='Selecione' />
				</DropdownContainer>
      </RightContainer>
  </Container>
  )
};

export default Complexidade;
